export { default } from './TargetProduct';
